<template>
	<div class="product-list-simple-item">
		<div class="d-flex align-items-center">
			<router-link :to="productPath" class="product-thumb" :title="product.name">
				<ximg :src="src" :ariaLabel="product.name" role="img" />
			</router-link>
			<div>
				<div>
					<router-link :to="productPath" :title="product.name">
						{{ product.name }}
					</router-link>
				</div>
				<div class="text-secondary">
					Artikelnr: {{  product.id }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import router from 'router';
import { urlFormat } from 'utils';
export default {
	props: ['product'],
	computed: {
		src () {
			return '/images/product/' + this.product.id + '?trim&h=80';
		},
		productPath () {
			return router.route({
				name: 'product',
				params: {
					id: this.product.id,
					name: urlFormat(this.product.name),
				},
			});
		},
	},
};
</script>
